// App-download targets used by the in-app update prompt (mobile `UpdateGate`),
// the `GET /app-config` defaults, the web marketing landing, and the deep-link
// Pages Functions. THE single source of truth - never hardcode the literals.
//
// Kept in its OWN zero-dependency leaf module (not the `app.ts` barrel) so the
// web marketing bundle + Cloudflare Pages Functions can deep-import
// `@verso/shared/src/constants/store-urls` without pulling zod + the full
// constant corpus. The `@verso/shared` barrel re-exports these (via
// `constants/index.ts`), so `import { APP_STORE_URL } from '@verso/shared'`
// keeps working for the mobile app + API.
//
// The `IOS_STORE_URL` worker secret can override the iOS default at runtime
// (via `GET /app-config`) without a release if the listing URL ever changes.
// The static `apps/web/public/**` files (download.js, deep-link HTML) mirror
// these literals with a pointer comment - they are copied verbatim and cannot
// import a module.
export const APP_STORE_URL = 'https://apps.apple.com/us/app/compass-where-to-next/id6778567118'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.heycompass.mobile'

// The bare numeric App Store id (the tail of APP_STORE_URL). The Apple Smart App
// Banner meta tag (`apple-itunes-app` content="app-id=...") needs the id alone,
// not the full URL - so it lives here as its own SoT rather than being re-parsed
// out of APP_STORE_URL at each call site.
export const APP_STORE_ID = '6778567118'
